import FaltantesView from "./FaltantesView";
export default FaltantesView;